import confirmationDialog from './confirmation-dialog'
import updateHandler from './update-handler'
import updateSwitch from './update-switch'

export default {
    confirmationDialog,
    updateHandler,
    updateSwitch
}
